// apps/web/src/lib/painel/home/ral-hex.ts — Fase 17.8, Plano 08 (UI-SPEC U-17; T-17.8-08-01).
// Mapa de DADOS das cores em aplicação nas cabines. Este arquivo é dado, não superfície estilizada (fica em lib/, fora do
// verificador premium, que só varre components/ e CSS). A API nunca manda hex: manda o texto cadastrado no item (`corCodigo`),
// e o texto livre NUNCA vira estilo — só o hex deste mapa entra num `style`; código fora do mapa vira cinza neutro com o código escrito.
//
// Os hex são aproximações sRGB das cores RAL Classic usadas na tela (a RAL não publica um sRGB oficial; as amostras são só
// referência visual, a cor exata é a do cadastro). Para acrescentar uma cor do piloto, basta uma linha aqui.

export const RAL_HEX: Readonly<Record<string, string>> = {
  '1023': '#FAD201', // Amarelo tráfego
  '3020': '#CC0605', // Vermelho tráfego
  '5010': '#0E294B', // Azul genciana
  '6005': '#2F4538', // Verde musgo
  '7016': '#293133', // Cinza antracite
  '7032': '#B8B799', // Cinza seixo
  '7035': '#CBD0CC', // Cinza claro
  '7040': '#9DA1AA', // Cinza janela
  '8017': '#45322E', // Marrom chocolate
  '9005': '#0E0E10', // Preto fosco
  '9006': '#A1A1A0', // Alumínio branco
  '9007': '#8F8F8F', // Alumínio cinza
  '9010': '#F1ECE1', // Branco puro
  '9016': '#F1F0EA', // Branco tráfego
};

export type CorNormalizada =
  | { readonly tipo: 'ral'; readonly codigo: string; readonly hex: string }
  | { readonly tipo: 'ptfe'; readonly codigo: 'PTFE' }
  | { readonly tipo: 'desconhecida'; readonly codigo: string };

const PADRAO_RAL = /^RAL[\s_-]*(\d{4})$/i;

/**
 * Normaliza o `corCodigo` do item: "RAL9005" e "RAL 9005" -> `{ tipo: 'ral', codigo: '9005', hex }`; "PTFE" -> `{ tipo: 'ptfe' }`;
 * RAL fora do mapa e qualquer outro texto -> `desconhecida` (o código escrito, sem hex). `null` ou vazio -> `null` (sem cor).
 */
export function normalizarCor(corCodigo: string | null | undefined): CorNormalizada | null {
  const texto = (corCodigo ?? '').trim();
  if (texto === '') return null;
  if (/^PTFE$/i.test(texto)) return { tipo: 'ptfe', codigo: 'PTFE' };
  const ral = PADRAO_RAL.exec(texto);
  if (ral !== null) {
    const codigo = ral[1] as string;
    const hex = Object.hasOwn(RAL_HEX, codigo) ? (RAL_HEX[codigo] as string) : undefined;
    return hex === undefined ? { tipo: 'desconhecida', codigo: `RAL ${codigo}` } : { tipo: 'ral', codigo, hex };
  }
  return { tipo: 'desconhecida', codigo: texto };
}

/** Texto curto da cor para o código sob a amostra e para o nome acessível: "9010", "PTFE" ou o texto cadastrado. */
export function codigoDaCor(cor: CorNormalizada): string {
  return cor.codigo;
}

/** Nome da cor na frase de acessibilidade: "RAL 7035", "PTFE" ou o texto cadastrado. */
export function nomeDaCor(cor: CorNormalizada): string {
  return cor.tipo === 'ral' ? `RAL ${cor.codigo}` : cor.codigo;
}
